// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"12dc32e0","787":"b2f36740","968":"02a5cb86"}[chunkId] + ".chunk.js";
};